export interface LensStudioBridge {
    getCapabilities(): Promise<Capabilities>;
    importAssets(assetIds: string[]): Promise<ImportResult>;
    uploadAsset(options: UploadOptions): Promise<UploadResult>;
    openExternalUrl(url: string): void;
}

export interface Capabilities {
    lensStudioVersion: string;
    theme?: string; // Theme key (e.g., "dark"). Absent or unrecognized → default light theme.
    sentryContext?: SentryContext;
}

export interface SentryContext {
    installId: string; // Persistent UUID per machine
    sessionId: string; // UUID generated per panel open — correlates events across Sentry projects
}

export interface ImportResult {
    successIds: string[];
    failedIds: { id: string; error: string }[];
}

export interface UploadOptions {
    assetId: string; // local Lens Studio asset entity id
    organizationId: string;
}

export interface UploadResult {
    assetId: string; // remote asset id returned by the backend
    organizationId: string;
    error?: string;
}

export type BridgeErrorCode = "BRIDGE_TIMEOUT" | "BRIDGE_NOT_FOUND" | "UNAUTHORIZED";

export class BridgeError extends Error {
    constructor(
        readonly code: BridgeErrorCode,
        message: string,
    ) {
        super(message);
        this.name = "BridgeError";
    }
}
